export const UNKNOWN_BOND_MODAL = 'UNKNOWN_BOND_MODAL';

export const UNKNOWN_BOND_MODAL_FORM = 'UNKNOWN_BOND_MODAL_FORM';
export const SUBMIT_UNKNOWN_BOND_MODAL_FORM = 'SUBMIT_UNKNOWN_BOND_MODAL_FORM';
